import { on, reducer } from 'ts-action';
import { Leads, Means, Signal } from '../../ecg/types/signal';
import * as rawSignalActions from '../actions/raw-signal.actions';
import * as ecgActions from '../../ecg/actions/ecg.actions';

export interface RawSignalState extends Signal {
  leads: Leads;
  frequency: number;
  means: Means;
}

declare module 'react-redux' {
  interface DefaultRootState {
    rawSignal: RawSignalState;
  }
}

const initialStateFactory = (): RawSignalState => ({
  leads: {},
  frequency: 250,
  means: {},
});

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(rawSignalActions.load, (state, { rawSignal }) => ({
    ...state,
    leads: rawSignal.leads,
    frequency: rawSignal.frequency,
    means: rawSignal.means,
  })),
);
